var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"AlgoliaEventsDateFilter__date",attrs:{"id":"js-datepicker","placeholder":_vm.placeholder}})
}
var staticRenderFns = []

export { render, staticRenderFns }